// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9642c17e","520":"49839900","737":"cd190e32"}[chunkId] + ".chunk.js";
};